import { RolodexEntryType } from 'types'
import { z } from 'zod'

const TagsSchema = z.record(z.string(), z.string().nullable())

const OptionalTimestamps = z.object({
  updated_at: z.coerce.date().optional(),
  created_at: z.coerce.date().optional(),
  last_updated_by: z.string().optional(),
})

export const ChartStageSchema = z.object({
  type: z.literal('chart'),
  chartID: z.string(),
})

export const StageSchema = z.discriminatedUnion('type', [ChartStageSchema])

export const TimeSeriesWorkbookDataSchema = z.object({
  name: z.string().optional(),
  stages: z.array(StageSchema),
})

export const TimeSeriesWorkbookEntryJSONSchema = z.object({
  id: z.string(),
  type: z.literal(RolodexEntryType.TIME_SERIES_WORKBOOK),
  data: TimeSeriesWorkbookDataSchema,
  tags: TagsSchema,
  ...OptionalTimestamps.shape,
})

export const TimeSeriesWorkbookEntrySchema = z.object({
  entry: TimeSeriesWorkbookEntryJSONSchema,
})

// ----- inferred types -----
export type ChartStage = z.infer<typeof ChartStageSchema>
export type Stage = z.infer<typeof StageSchema>
export type TimeSeriesWorkbookData = z.infer<
  typeof TimeSeriesWorkbookDataSchema
>
export type TimeSeriesWorkbookEntryJSON = z.infer<
  typeof TimeSeriesWorkbookEntryJSONSchema
>
export type TimeSeriesWorkbookEntry = z.infer<
  typeof TimeSeriesWorkbookEntrySchema
>
